/**
 * converts string to kebab case
 * @param str - alphanumeric characters only
 */
export const toKebabCase = (string: string) =>
  string
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/[\s_]+/g, '-')
    .toLowerCase();
